import { module } from 'angular';

import { default as videoconferenceName, VideoconferenceRequest } from './videoconference.component';
import { default as videoconferenceServiceName, VideoconferenceService } from './videoconference.service';

export default module('contact.agent.core.channel-digit.videoconference', [])
  // instanciate services module
  .run([videoconferenceServiceName, () => {}])
  // service
  .service(videoconferenceServiceName, VideoconferenceService)
  // component
  .component(videoconferenceName, new VideoconferenceRequest()).name;
